import { EVENT_TYPES } from './constants';

const getEvent = (type, key?, value?): CustomEvent =>
  key && value
    ? new CustomEvent(type, { detail: { [key]: value } })
    : new CustomEvent(type);

export default {
  stopGame: () => getEvent(EVENT_TYPES.stopGame),
  swapEntities: (fresh) =>
    getEvent(EVENT_TYPES.swapEntities, 'entities', fresh),
  onKeyDown: (label) => getEvent([EVENT_TYPES.onKeyDown], 'character', label),
  onInputPadSend: (label) =>
    getEvent([EVENT_TYPES.onInputPadSend], 'character', label),
  onRecordPadSend: () => getEvent(EVENT_TYPES.onRecordPadSend),
  yTPSC: (data) => getEvent(EVENT_TYPES.yTPSC, 'playerState', data),
};
